export default {
    domain: 'https://analytics.accupin.com/',
    baseApi: 'https://analytics.accupin.com/api',
};